module.exports = __webpack_public_path__ + "static/media/addItem.1a07c2ef.svg";